<div class="flex w-full min-h-screen">
  <aside class="
      fixed
      top-0
      left-0
      z-30
      h-screen
      w-[288px]
      shrink-0
      bg-surface-container-lowest
      overflow-y-auto
      -translate-x-full
      lg:sticky
      lg:top-0
      lg:left-auto
      lg:translate-x-0
      lg:h-screen
      lg:self-start
    ">
    <app-customer-area-menu></app-customer-area-menu>
  </aside>

  <main class="relative flex-1 min-w-0 pb-32 lg:pb-0">
    <app-buttons-layout *ngIf="showBackButton"></app-buttons-layout>
    <router-outlet id="customer-area"></router-outlet>
  </main>

  <app-customer-area-bottom-menu></app-customer-area-bottom-menu>
</div>
